export default "__VITE_ASSET__DGsD$BRs__"